import { requestService as api } from "../Request.service";

const API_URL = {
  API_MANAGE: `/ERP/fg-handover/manage.php`,
  API_SEARCH: `/ERP/fg-handover/search.php`,
};

/* ใบส่งมอบ FG (ฝ่ายผลิต → คลังสินค้า) */
const FgHandoverService = () => {
  const get = (fhcode) => api.get(`${API_URL.API_MANAGE}?code=${encodeURIComponent(fhcode)}`);
  /* FG ใน PD พร้อมยอดสั่งผลิต / ส่งมอบไปแล้ว */
  const prefill = (pdcode) =>
    api.get(`${API_URL.API_MANAGE}?prefill=${encodeURIComponent(pdcode)}`);
  /* PD ที่ส่งมอบได้ (มีใบเบิกวัตถุดิบตัดสต๊อกแล้ว) */
  const pdOptions = (q = "") =>
    api.get(`${API_URL.API_MANAGE}?pd_options=1&q=${encodeURIComponent(q)}`, { ignoreLoading: true });

  const create = (parm = {}) => api.post(API_URL.API_MANAGE, { ...parm, action: "create" });
  const update = (parm = {}) => api.put(API_URL.API_MANAGE, parm);
  const confirm = (parm = {}) => api.post(API_URL.API_MANAGE, { ...parm, action: "confirm" });
  const cancel = (fhcode) => api.post(API_URL.API_MANAGE, { fhcode, action: "cancel" });

  const search = (parm = {}, config = {}) =>
    api.post(API_URL.API_SEARCH, parm, { ...config, cancle: true });

  return { get, prefill, pdOptions, create, update, confirm, cancel, search };
};

export default FgHandoverService;
